<form [formGroup]="form">
  <div mat-dialog-title class="title-container">
    <h2>{{ 'building.status.editionOfTheStatus' | transloco }} ({{ 'building.buildingsCount' | transloco : { count } }})</h2>
  </div>

  <div class="status-edit-content">
    <div class="chip-status">
      <mat-chip-listbox aria-label="Status list">
        @for (status of buildingStatusList; track status) {
        <mat-chip-option (click)="addStatus(status.key)" [class.selected]="status.key === selectedStatus" class="custom-chip">
          @if (status.key === selectedStatus) {
          <mat-icon matChipAvatar>check</mat-icon>
          }
          {{ status.label }}
        </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>

    <mat-form-field>
      <mat-label>{{ 'building.status.justification' | transloco }}</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="10"
        formControlName="justification"
      ></textarea>
    </mat-form-field>

    @if (building) {
    <p>
      {{ 'building.status.lastUpdate' | transloco }}&nbsp; <strong>{{ statusDate }}</strong
      >&nbsp; {{ 'building.status.by' | transloco }}&nbsp;
      <strong>{{ 'building.status.sourceOfChange' | transloco : { source: building?.buildingStatus.user.role } }}</strong>
    </p>
    }
  </div>

  <mat-dialog-actions align="end">
    <sibat-validate-button
      class="mat-button-base"
      (clicked)="save()"
      [label]="'building.documents.validate' | transloco"
      [disabled]="!form.valid"
    >
    </sibat-validate-button>

    <sibat-secondary-button class="mat-button-base" (click)="cancel()" [label]="'building.documents.cancel' | transloco">
    </sibat-secondary-button>
  </mat-dialog-actions>
</form>
